import React from 'react';
import CodeBlock from '../components/CodeBlock';

const Workspaces = () => {
  return (
    <div className="page">
      <div className="page-header">
        <h1>Workspaces</h1>
        <p>
          Récupérez la liste de tous les workspaces accessibles pour votre compte.
        </p>
      </div>

      <div className="section">
        <h2>GET /api/public/workspaces</h2>
        <p>
          Retourne tous les workspaces auxquels l'utilisateur authentifié a accès.
        </p>

        <div className="endpoint-card">
          <div className="endpoint-header">
            <span className="method-badge method-get">GET</span>
            <span className="endpoint-path">/api/public/workspaces</span>
          </div>
          <div className="endpoint-description">
            Récupère tous les workspaces de l'utilisateur authentifié via API Key
          </div>

          <div className="alert alert-info" style={{ marginTop: '1rem', marginBottom: '1rem' }}>
            ⚠️ Nécessite authentification JWT
          </div>

          <h4>Headers requis:</h4>
          <table className="params-table">
            <thead>
              <tr>
                <th>Header</th>
                <th>Description</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td><code>Authorization</code></td>
                <td>Bearer JWT_TOKEN (obtenu via /api/public/auth)</td>
              </tr>
              <tr>
                <td><code>Content-Type</code></td>
                <td>application/json</td>
              </tr>
            </tbody>
          </table>

          <h4>Exemple de requête:</h4>
          <CodeBlock
            code={`curl -X GET http://127.0.0.1:8000/api/public/workspaces \\
  -H "Authorization: Bearer VOTRE_JWT_TOKEN" \\
  -H "Content-Type: application/json"`}
            language="curl"
            showCopy={true}
          />

          <h4>Réponse:</h4>
          <CodeBlock
            code={`{
  "user": {
    "id": 123,
    "email": "user@exemple.com",
    "firstName": "John",
    "lastName": "Doe"
  },
  "workspaces": [
    {
      "id": 456,
      "title": "Mon Workspace 1",
      "vatNumber": "FR12345678901",
      "role": "admin",
      "createdAt": "2024-01-15T10:30:00Z"
    },
    {
      "id": 789,
      "title": "Mon Workspace 2",
      "vatNumber": "FR98765432109",
      "role": "user",
      "createdAt": "2024-01-20T14:00:00Z"
    }
  ]
}`}
            language="json"
            showCopy={true}
          />
        </div>
      </div>
    </div>
  );
};

export default Workspaces;
